<div class="fullscrOuter">
    <div class="fullscrMiddle">
        <div class="fullscrInner">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>